import React, { Suspense, lazy, useState } from "react";
import { Route } from "react-router-dom";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import { UserChildsUIProvider } from "./UserChildsUIContext";
import { UnassignedAccountsTable } from "./UnassignedAccountsTable";
import { UnassignedCustomersGrouping } from "./grouping/UnassignedCustomersGrouping";
import { UnassignedCustomersFetchDialog } from "./grouping/UnassignedCustomersFetchDialog";

export function UnassignedCustomers({ history }) {
  const customersUIEvents = {
    openFetchCustomersDialog: () => {
      history.push(`/unassigned-customers/fetch`);
    },
    // openUpdateCustomersStatusDialog: () => {
    //   history.push("/customers/updateStatus");
    // },
  };

  return (
    <UserChildsUIProvider customersUIEvents={customersUIEvents}>
      <Card>
        <Route path="/unassigned-customers/fetch">
          {({ history, match }) => (
            <UnassignedCustomersFetchDialog
              show={match != null}
              onHide={() => {
                history.push("/unassigned-customers");
              }}
            />
          )}
        </Route>

        <CardHeader title="Unassigned Customers"></CardHeader>

        <CardBody>
          <div className="container">
            <UnassignedCustomersGrouping />
            <UnassignedAccountsTable />{" "}
          </div>
        </CardBody>
      </Card>
    </UserChildsUIProvider>
  );
}
